import PropTypes from 'prop-types';

export const StringOrNumber = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
export const StringOrReact = PropTypes.oneOfType([PropTypes.string, PropTypes.element])
